export default __webpack_public_path__ + "img/location-field.54a23215.svg";